import React from 'react';
import styled from 'styled-components';

const RakutenLogoWrapper = styled.div`
    width: 120px;
    height: 100%;
`;

const RakutenLogo = () => (
    <RakutenLogoWrapper>
        <svg viewBox="0 0 84 25" aria-label="Rakuten" role="img">
            <path
                d="M50.7111 7.72206e-07H3.85737e-07L4.04475 4.04858L50.7111 7.72206e-07Z"
                transform="translate(16.7857 20.9514)"
                fill="#BF0000"
            />
            <path
                d="M9.20181 0.354251V0.961538C8.24118 0.354251 7.43223 9.65257e-08 6.26936 9.65257e-08C2.73021 9.65257e-08 -3.85737e-07 3.23887 -3.85737e-07 7.23684C-3.85737e-07 11.2348 2.67965 14.4737 6.26936 14.4737C7.43223 14.4737 8.29174 14.1194 9.20181 13.5121V14.1194H12.3365V0.354251H9.20181ZM6.2188 11.1842C4.44922 11.1842 3.18524 9.46356 3.18524 7.28745C3.18524 5.11134 4.44922 3.39069 6.2188 3.39069C7.98838 3.39069 9.20181 5.11134 9.20181 7.28745C9.25237 9.46356 7.98838 11.1842 6.2188 11.1842Z"
                transform="translate(12.2859 4.20044)"
                fill="#BF0000"
            />
            <path
                d="M8.29174 0V8.09717C8.29174 9.61538 7.22999 10.8806 5.71321 10.8806C4.19643 10.8806 3.13468 9.61538 3.13468 8.09717V0H-7.71475e-07V8.09717C-7.71475e-07 11.4372 2.27517 14.1194 5.61209 14.1194C7.12887 14.1194 8.29174 13.2591 8.29174 13.2591V13.7652H11.4264V0H8.29174Z"
                transform="translate(38.2229 4.55469)"
                fill="#BF0000"
            />
            <path
                d="M3.13468 14.1194V6.02227C3.13468 4.50405 4.19643 3.23887 5.71321 3.23887C7.22999 3.23887 8.29174 4.50405 8.29174 6.02227V14.1194H11.4264V6.02227C11.4264 2.68219 9.15125 -1.93051e-07 5.81433 -1.93051e-07C4.29754 -1.93051e-07 3.13468 0.860324 3.13468 0.860324V0.303644H-3.0859e-06V14.0688H3.13468V14.1194Z"
                transform="translate(72.5021 4.2511)"
                fill="#BF0000"
            />
            <path
                d="M3.28636 17.2571V11.8927H5.56153L9.55572 17.2065H13.651L8.79733 10.7794C10.3141 9.7166 11.2747 7.94534 11.2747 5.92105C11.2747 2.63158 8.5951 2.41314e-08 5.35929 2.41314e-08H0V17.2065H3.28636V17.2571ZM3.28636 3.28947H5.40985C6.87608 3.28947 8.0895 4.50405 8.0895 5.97166C8.0895 7.43927 6.87608 8.65384 5.40985 8.65384H3.28636V3.28947Z"
                transform="translate(0 1.1134)"
                fill="#BF0000"
            />
            <path
                d="M7.33111 13.9676C7.02776 14.17 6.67384 14.3219 6.26936 14.3219C5.76377 14.3219 4.80314 13.917 4.80314 12.6518V6.73077H7.48279V3.4413H4.80314V2.41314e-08H1.66846V3.4413H1.54295e-06V6.73077H1.66846V12.6518C1.66846 15.7389 3.99419 17.5607 6.31992 17.5607C7.17943 17.5607 8.39286 17.2571 9.35349 16.7004L7.33111 13.9676Z"
                transform="translate(50.7111 1.1134)"
                fill="#BF0000"
            />
            <path
                d="M5.96601 11.0324L11.3253 4.55466H6.97719L3.18524 9.36235V0H3.85737e-07V18.3704H3.18524V12.7024L7.8367 18.3704H12.1848L5.96601 11.0324Z"
                transform="translate(26.392)"
                fill="#BF0000"
            />
            <path
                d="M6.21881 9.65257e-08C2.57853 9.65257e-08 1.54295e-06 3.18826 1.54295e-06 7.23684C1.54295e-06 11.4879 3.2358 14.4737 6.52216 14.4737C8.19062 14.4737 10.2636 13.917 12.0331 11.3866L9.25237 9.76721C7.12888 12.9049 3.53916 11.336 3.13468 8.14777H12.1343C12.9432 3.28947 9.75796 9.65257e-08 6.21881 9.65257e-08ZM8.94901 5.46559H3.33692C3.99419 2.27733 8.3423 2.0749 8.94901 5.46559Z"
                transform="translate(59.0534 4.20044)"
                fill="#BF0000"
            />
        </svg>
    </RakutenLogoWrapper>
);

export default RakutenLogo;
